<template>
	<v-container class="mt-sm mb-2xl px-sm">
		<v-h3 tag="h1" class="mt-md">
			{{ t("gift-card") }}
		</v-h3>

		<p class="my-md">{{ t("gift-card-text") }}</p>

		<form @submit.prevent="checkCode">
			<div class="grid grid-cols-1 gap-xs">
				<div class="flex flex-row items-center gap-2">
					<p class="text-sm">{{ t("enter-gift-card-code") }}</p>

					<v-input
						v-model="input"
						type="text"
						name="code"
						size="sm"
						:placeholder="t('gift-card-code')"
					/>
				</div>

				<div class="flex-1 justify-center">
					<v-button
						class="flex items-center justify-center border border-solid border-red-500 bg-red-500 p-1 text-white"
						type="submit"
					>
						{{ t("check-code") }}
					</v-button>
				</div>
			</div>
		</form>
	</v-container>
</template>

<script setup lang="ts">
const input = ref("");
const {t} = useI18n();

function checkCode() {
	if (input.value.length > 0) {
		navigateTo(`/gift-card/${input.value}`);
	}
}
</script>

<!-- eslint-disable max-len -->
<i18n lang="json">
{
	"et": {
		"gift-card": "Gift Card",
		"enter-gift-card-code": "Enter gift card code",
		"check-code": "Check code",
		"gift-card-code": "Gift Card Code",
		"gift-card-text": "Gift cards are a great way to give a gift to someone. They can be used to buy products in our store. Enter the code below to check if it is valid and see how much money is left on the card."
	},
	"fi": {
		"gift-card": "Lahjakortti",
		"enter-gift-card-code": "Syötä lahjakortin koodi",
		"gift-card-code": "Lahjakortin koodi",
		"check-code": "Tarkista koodi",
		"gift-card-text": "Syötä alla olevaan kenttään lahjakortin koodi ja tarkista, onko lahjakortti vielä voimassa ja kuinka paljon kortilla on rahaa jäljellä."
	}
}
</i18n>
